import React from 'react'

export default class GroupsListItem extends React.Component {
  render() {
    const { group, selectedGroups, toggleGroup } = this.props

    return (
      <tr key={group.id}>
        <td className='table__checkbox'>
          <input
            type='checkbox'
            value={group.id}
            checked={selectedGroups.has(group.id)}
            onChange={toggleGroup}
          />
        </td>
        <td
          className={`table__group-name${
            group.users && group.users.length ? ' table__group-name--link' : ''
          }`}
          onClick={
            group.users && group.users.length
              ? () => this.props.fetchGroup(group.id)
              : () => {
                  return false
                }
          }>
          {group.title}
        </td>
        <td className='table__users-count'>{group.users.length}</td>
        <td className='table__controllers'>
          {this.props.getNameControllers(group.access_object)}
        </td>
      </tr>
    )
  }
}
